export default {
  'create.payment.title': 'Initiate Payment',
  'create.payment.description':
    'Please ensure that transactions are approved prior to the displayed cut-off time.',
  'create.payment.charges': 'charges',
  'create.payment.type': 'Payment Type',
  'create.payment.payeeName': 'Payee Name',
  'create.payment.amount': 'Amount',
  'create.payment.purpose': 'Purpose of Wire',
  'create.payment.error': 'Something went wrong',

  'create.payment.info.amountDebited': 'Debit Amount',
  'create.payment.info.estimatedAmountDebited': 'Estimated Amount to be Debited',
  'create.payment.info.amountSent': 'Send Amount:',
  'create.payment.info.exchangeRateWarning': 'Rate may not be final',
  'create.payment.info.appliesToRateConfirm': 'This applies to the custom rate',
  'create.payment.info.mustBeGrater': 'Must be greater than 0',

  // Validation
  'create.payment.validation.msgAmount': 'min 1 max 12 characters',
  'create.payment.validation.msgRequired': 'Required information cannot be blank',
  'create.payment.validation.required': 'Required information cannot be blank',
  'create.payment.validation.success': 'Validation has been succeeded',
  'create.payment.validation.404': 'Requested payment not found',
  'create.payment.validation.templateExists': 'Payment template already exists',
  'create.payment.validation.templateName': 'Invalid template name',
  'create.payment.validation.templateCode': 'Invalid template code',
  'create.payment.validation.paymentMethod': 'Payment method required',
  'create.payment.validation.bankTrace': 'Requested bank trace not found',
  'create.payment.validation.paymentType': 'Payment type is not valid',
  'create.payment.validation.amount': 'Invalid amount to initiate a wire payment',
  'create.payment.validation.transactionDate':
    'The transaction date selected is a non-business day.',
  'create.payment.validation.transactionLimit':
    "Amount exceeds the user's transaction entry limit",
  'create.payment.validation.bankTemplateLimit': 'Amount exceeds bank template limit',
  'create.payment.validation.dailyTransactionLimit':
    'Amount exceeds daily transaction total limit',
  'create.payment.validation.dailyBankTemplateLimit': 'Amount exceeds daily bank template limit',
  'create.payment.validation.transactionApprovalLimit':
    'Amount exceeds transaction approval limit',
  'create.payment.validation.bankTemplateApprovalLimit':
    'Amount exceeds bank template approval limit',
  'create.payment.validation.dailyTransactionApprovalLimit':
    'Amount exceeds daily transaction approval limit',
  'create.payment.validation.dailyBankTemplateApprovalLimit':
    'Amount exceeds daily bank template approval limit',
  'create.payment.validation.rateNotAllowedToModify': 'Exchange Rate cannot be modified',
  'create.payment.validation.chargesNotAllowedToDisplay': 'Charges cannot be displayed',
  'create.payment.validation.intermediaryBankNotAllowed':
    'Intermediary Bank Information cannot be entered',
  'create.payment.validation.invalidCharacterNotAllowed': 'You have entered invalid characters',
  'create.payment.validation.provideRateConfirmation': 'Custom Rate Confirmation is required',
  'create.payment.validation.submitUserLimits': 'Please submit user limits',
  'create.payment.validation.missingApprovalReq':
    'Approval requirements are not set up for the account',

  'create.payment.maxLength': 'Max length has been exceeded',
  'create.payment.successPayment': 'Payment has been created',
  'create.payment.successTemplate': 'Template created',
  'create.payment.back': 'LEAVE PAGE',
  'create.payment.back.confirm': 'Are you sure you want to leave this page?',
  'create.payment.back.confirm.line2': 'All unsaved changes will be lost.',
  'create.payment.loanCreate': 'Loan Payment',
  'create.payment.loanDraw': 'Loan Draw',
  'create.payment.domestic': 'Domestic',
  'create.payment.international': 'International',

  'modify.payment.title': 'Modify Payment',
  'modify.payment.success': 'Payment has been modified',

  'user.txn.account.limit_error': 'User Transaction count limit error',
  'user.txn.day.amount.limit.error': 'User Transaction day amount limit error',
  'user.txn.max.ammount.limit.error': 'User Transaction max amount limit error',
  'user.initiate.loan.txn.fail': 'Initiate Loan PAYMENTS/DRAWS transaction failed'
};
